import { ReactNode } from "react";
import { icons, sectionSettings } from "../../Helpers/WindowHelpers";
import parse from 'html-react-parser';
interface HeaderStepMobileInterface {
    title: string,
    stepNumber: number,
    stepValue: number,
    setStep: (step: number) => void,
    children?: ReactNode,
    classes?: string
}
const HeaderStepMobile = ({ title, stepNumber, stepValue, setStep, children, classes }: HeaderStepMobileInterface) => {
    const active = stepNumber == (stepValue - 2) ? 'is-active' : '';
    const complete = stepNumber > (stepValue - 2) ? 'is-complete' : '';

    const editSelected = () => {
        setStep(stepValue - 2);
    }
    return (
        <div className={`configurator-steps__step d--flex align-items--start is-step-${stepValue} ${active} ${complete} ${classes || ''}`}>
            {/* @ts-ignore */}
            <details className={`configurator-steps__toggle ${active}`} name="configurator-summary" aria-disabled={!(active || complete)}>
                <summary role="button" className="configurator-steps__step--inner">
                    <span className={`configurator-steps__count flex-center ${active} ${complete}`}>
                        {stepValue < 10 ? '0':''}{stepValue}
                    </span>
                    <span className="configurator-steps__title d--flex align-items--center gap-10">
                        {title}
                        {(active || complete) && <span>{parse(icons.caretDown ?? '')}</span>}
                    </span>
                </summary>
                <div className="configurator-steps__dropdown">
                    {children}
                </div>
            </details>
            {(active || complete) && <button className="configurator-steps__edit link ml-auto" type="button" onClick={() => editSelected()}>{sectionSettings.label_edit}</button>}
        </div>
    )
}

export default HeaderStepMobile;